<template>
  <v-layout>
    <v-container grid-list-md>
      <v-card light>
        <v-card-text style="text-align:center" v-if="!cloading && classes.length == 0">
          <h3>No class found.</h3>
        </v-card-text>
        <v-card-text style="text-align:center" v-if="cloading">
          <v-progress-circular
            :indeterminate="true"
            :rotate="0"
            :size="68"
            :value="''"
            :width="3"
            color="light-blue"
          >{{ 'loading...' }}</v-progress-circular>
        </v-card-text>
        <v-card-text v-else>
          <v-layout row wrap>

            <v-flex xs12>
                <v-form ref="prform">
              <v-layout row wrap>
                <v-flex xs12>
                  <v-autocomplete
                    label="Promote Students From:"
                    :items="classes"
                    item-text="name"
                    :return-object="true"
                    v-model="sel_frmclass"
                    :rules="validRules.required"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs12>
                  <!-- <v-autocomplete label="To:" :items="toclasses" item-text="name" item-value="id"  v-model="promo_model.to_class" :rules="validRules.required" v-if="sel_frmclass?sel_frmclass.id!=max_class_id:true"></v-autocomplete> old way-->

                  <v-autocomplete label="To:" :items="toclasses" item-text="name" item-value="id"  v-model="promo_model.to_class" :rules="validRules.required" v-if="sel_frmclass?sel_frmclass.name!='Basic 9':true"></v-autocomplete>
                </v-flex>
                <v-flex xs12>
                  <v-autocomplete label="Excluded Students:" :multiple="true" :items="cls_stds" item-text="name" item-value="id" v-model="excl_stds"></v-autocomplete>
                </v-flex>
              </v-layout>
                </v-form>
            </v-flex>

          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <!-- <v-btn style="cursor:pointer" color="success" @click="promote()">{{sel_frmclass && sel_frmclass.id==max_class_id?"Graduate":"Promote"}}</v-btn> old way-->
           <v-btn style="cursor:pointer" color="success" @click="promote()">{{sel_frmclass && sel_frmclass.name=='Basic 9'?"Graduate":"Promote"}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-container>
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "report-cards",
  props: {
    trigpromo: {
      //trigger promotion
      type: Boolean
    }
  },
  data() {
    return {
      excl_stds:[],
      sel_frmclass:null,
      promo_model:{
        frm_class:'',
        to_class:'',
        sel_stds:[]
      },
       promo_modelcp:{
        frm_class:'',
        to_class:'',
        sel_stds:[]
      }
    };
  },
  created() {
    this.$store.dispatch("settings/getAll");

  },
  methods: {
    promote(){
      let pstate = (this.sel_frmclass.id==this.max_class_id)?'graduation':'promotion'
      if(!this.$refs.prform.validate()){
        return
      }
      if(confirm("Please confirm this "+ pstate+" by clicking OK")){
        //console.log(this.sel_frmclass)
        if(this.sel_frmclass.students_count>0 && this.sel_frmclass.students.length==0){
          pstate=pstate=="graduation"?"graduated":"promoted";
          alert("Students for the selected class have already been "+pstate+" for the currently set academic year(Note: please check if academic year in settings is set to the most current academic year)");
          return
        }

        if(this.sel_frmclass.students_count<=0){
          let pstate = (this.sel_frmclass.id==this.max_class_id)?'graduated':'promoted'
          alert("class has no students to be "+pstate);
          return;
        }

        this.$store.dispatch('students/promote',this.promo_model).then(res=>{
          if(this.sterrors==null){
            this.$store.dispatch("classes/getPromoClasses");
            this.promo_model = this.promo_modelcp
            this.sel_frmclass = null
          }
        })
        //console.log('sel...',this.promo_model.sel_stds)
      }
    }
  },
  computed: {
    ...mapGetters({
      classes: "classes/PROMOCLASSES",
      cerrors: "classes/CLASS_ERROR",
      cloading: "classes/CLASS_LOADING",

      settings: "settings/SETTINGS",
      serrors: "settings/SETTING_ERROR",
      sloading: "settings/SETTING_LOADING",

      sterrors: "students/STUDENT_ERROR",
    }),
    toclasses(){
      if(this.sel_frmclass){
        let c = this.classes.filter(x=>{
          return Number(x.level)>Number(this.sel_frmclass.level)
        })

        return c
      }else{
        return []
      }

    },

    cls_stds(){
      if(this.sel_frmclass){
        return this.sel_frmclass.students.map(x=>{
          return {
            id:x.id,
            name:x.s_bio.name+'('+x.rollno+')',
            acyear:x.curr_acyear
          }
        })
      }else{
        return []
      }
    },
    max_class_id(){
      if(this.classes){
        let top_class = this.classes[this.classes.length-1];
        return top_class.id
      }
    }
  },
  watch: {
    trigpromo(val) {
      if (val == true) {
        this.$store.dispatch("classes/getPromoClasses");
      }else{
        this.promo_model=this.promo_modelcp
        this.sel_frmclass = null
      }
    },
    excl_stds(val){
     // console.log("exc",val)
      if(val && this.sel_frmclass){
        this.promo_model.sel_stds = this.sel_frmclass.students.filter(x=>{
          return val.includes(x.id)?false:true
        }).map(s=>s.id)
        console.log("efddg",this.promo_model.sel_stds)

      }
    },
    sel_frmclass(val){
      if(val){
        this.promo_model.sel_stds = val.students.map(x=>x.id)
        this.promo_model.frm_class = val.id
        if(val.id==this.max_class_id){
          //alert("heey")
          this.promo_model.to_class=null
        }
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/student/promotion.vue